import { render, staticRenderFns } from "./Callback.vue?vue&type=template&id=50380fc6&scoped=true&"
import script from "./Callback.vue?vue&type=script&lang=js&"
export * from "./Callback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50380fc6",
  null
  
)

export default component.exports